module.exports = __webpack_public_path__ + "static/media/Beautiful Earth video for the GBX site.24b454da.mp4";